<template>
    <div class="navbar">
        <v-navigation-drawer
                v-model="drawer"
                app
                right
                class="slider">
            <v-toolbar flat class="transparent">
                <v-list class="pa-0">
                    <v-list-tile avatar>
                        <v-list-tile-avatar>
                            <img v-if="userInfo.avatar" :src="userInfo.avatar">
                            <v-icon v-else="userInfo.avatar">user</v-icon>
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                            <v-list-tile-title>{{ userInfo.name }}</v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>
                </v-list>
            </v-toolbar>
            <v-list dense>
                <v-divider></v-divider>
                <v-list-tile @click="$router.push({path: '/epmc'})">
                    <v-list-tile-action>
                        <v-icon>home</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title>首页</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
                <v-list-tile @click="$router.push({path: '/epmc'})">
                    <v-list-tile-action>
                        <v-icon>contact_mail</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title>填写工时</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
                <v-list-tile @click="$router.push({path: '/changePwd'})">
                    <v-list-tile-action>
                        <v-icon>edit</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title>修改密码</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
                <v-list-tile @click="logout">
                    <v-list-tile-action>
                        <v-icon>remove_circle</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title>退出登陆</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
            </v-list>
        </v-navigation-drawer>
    </div>
</template>

<script>
    import {mapGetters, mapMutations} from 'vuex'

    export default {
        name: "NavBar",
        data() {
            return {
                userInfo: {
                    avatar: '',
                    name: ''
                },
                code: '',
                openId: ''
            }
        },
        methods: {
            ...mapMutations('sysAdmin', ['SET_DRAWER']),

            logout() {
                localStorage.clear()
                window.location.reload()
                // this.$router.push({path: '/login'})
            },
            loadWxUser() {
                let wxUser = localStorage.getItem("wechatUser")
                if (wxUser) {
                    let obj = JSON.parse(wxUser)
                    if (obj) {
                        this.userInfo.avatar = obj.headImgUrl
                        this.userInfo.name = obj.nickname
                    }
                }
            },
            showPwdDlg() {

            }
        },
        mounted() {
            this.loadWxUser()
        },
        computed: {
            drawer: {
                get() {
                    return this.$store.state.sysAdmin.drawer
                },
                set(value) {
                    this.SET_DRAWER(value)
                }
            },

        },
        watch: {
            '$store.state.sysAdmin.drawer'(to, from) {
                this.drawer = to
            },

        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// NavBar.vue?302a7d22